<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                        <h3>إضافة <small>طلب انضمام ابنائي</small></h3>
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسية'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسية</router-link>
                                </li>
                                <li>
                                  <router-link :title="'المستخدمين'" :to="{name: 'requests'}">طلبات انضمام ابنائي</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'اضافة'" :to="{name: 'requests.create'}">اضافة</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                

                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">                                
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>بيانات الطلب</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                               
                                <form @submit.prevent="store()">
                                     <div class="row">
                                  <div class="form-group col-md-4 mb-4">
                                        <label for="exampleFormControlInput12">الاسم</label>
                                        <input type="text" class="form-control" id="exampleFormControlInput12" v-model="data.form.name" placeholder="الاسم كامل">
                                        <div class="invalid-feedback" :style="getErrors['name'] ? 'display: block' : 'display: none;'"  v-if="getErrors['name']">
                                              {{ getErrors['name'][0] }}
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4 mb-4">
                                        <label for="exampleFormControlSelect1">المرحلة الدراسية</label>
                                        <treeselect :options="stages" v-model="data.form.stage_id" @select="getGroupsByStage" :multiple="false"/>

                                        <div class="invalid-feedback" :style="getErrors['stage_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['stage_id']">
                                              {{ getErrors['stage_id'][0] }}
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4 mb-4">
                                        <label for="exampleFormControlSelect1">الصف</label>
                                        <treeselect :options="groups" v-model="data.form.group_id"  @select="setStage" :multiple="false"/>

                                        <div class="invalid-feedback" :style="getErrors['group_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['group_id']">
                                              {{ getErrors['group_id'][0] }}
                                        </div>
                                    </div>
                                    
                                     </div>
                                    <!-- <input type="submit" name="time" class="mt-4 mb-4 btn btn-button-7" value="حفظ"> -->
                                    <button type="submit" name="time" class="mt-4 mb-4 btn btn-button-7"><i class="fa fa-save"></i> حفظ</button>
                               
                                </form>
                            </div>
                           
                        </div>
                    </div>

                </div>

            </div>

</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    Treeselect,
  },
  data() {
    return {
        groups: [],
        stages: [],
      data: {
        checker: false,
        form:{
            name: '',
            group_id: '',
            stage_id: '',
        },
        roles: {
        },
        options: [],
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){
    this.getRequirements();
  },
  methods: {
      store(){
          this.data.isRequested = true;
         this.$baseApi.post('/requests', this.data.form).then((response)=>{
            if(response.data.code === 200){
              localStorage.setItem('flash_message', 'تمت عملية الاضافة');
                router.push('/requests');
            }
        }).catch((error) => {
            this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
            this.data.isRequested = false
          })
      },
      getRequirements(){
        this.getOptions();
      },
      getOptions(){
        this.$baseApi.get('/requests/create').then((response)=>{
            if(response.data.code == 200){
               this.groups = response.data.data.groups;
               this.stages = response.data.data.stages;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
       getGroupsByStage(val){
        this.data.form.group_id = '';
        this.$baseApi.get('/parents/create?option=group&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.groups = response.data.data.groups;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      setStage(val){
        this.$baseApi.get('/parents/create?option=stage&s='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.data.form.stage_id = response.data.data.stage.id;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    }
  }
};
</script>
<style>
</style>
